import React, { useState } from 'react';
import { KeyDownEventLink } from '../../../utils/eventKey';
import GoalServices from "../../../services/goal.services";
import { useTranslation } from 'react-i18next';
type clusterItemProps = {
    metric: any,
    clusterData: any,   
    actions?: any,
    saveItems: (item?: any, id?:any) => void
    clusterFlag:boolean
};

const KrClusterItem = (props: clusterItemProps) => {
    const { t } = useTranslation()
    const { metric, clusterData, actions,clusterFlag } = props;
    const [krHover, setKrHover] = useState(false);
    const GoalServicesInstance = new GoalServices();
    const viewGoalDetails = () => {
  		return metricDetailsPage(clusterData.id);
    }

    const updateAsMirrorItem = (e) => {
        let mertricID = metric && metric.id && metric.id != '' ? metric.id : ''
        GoalServicesInstance.getClusterFireEvent({type: 'KR_CLUSTER_MIRROR_SELECTED ', source: mertricID != '' ? 'KR_EDIT' : 'KR_SIMPLE_CREATE'})
        props.saveItems(clusterData, mertricID);
    }

    const IntervalTexts = {
        1: t("daily"),
        2: t("weekly"),
        3: t("monthly"),
        4: t("quarterly"),
        5: t("once")
      };
      
    const MetricValueText = progress_type => {
      let text = t("Last value");
      if (progress_type == "1") {
        text = t("Last value");
      } else if (progress_type == "2") {
        text = t("Sum");
      } else if (progress_type == "3") {
        text = t("Average");
      } else if (progress_type == "4") {
        text = t("Sum of last value");
      }
      return text;
    };

    let intervalText =
      typeof IntervalTexts[clusterData.interval] && clusterData.interval != "0"
        ? IntervalTexts[clusterData.interval]
        : "";
    
    let targetText = clusterData.targetDisplay
      ? clusterData.achieveTargetText + ` ${t('of')} ` + clusterData.totalTargetText
      : clusterData.achieveTargetText;
    
    let subtitle1 = "";
    
    if (clusterData.source == 1) {
      subtitle1 = clusterData.kr_owner;
    } else {
      subtitle1 = clusterData.source_from
        ? clusterData.kr_owner : "";
    }
    
    let subtitle2 = `${t('Progress')} | ${MetricValueText(
          clusterData.progress_type || ""
        )} ${t('of')} ${intervalText} ${t('updates')}`;
    
    return (
        <>
        <div className='clusterKrRectangle' 
                onMouseEnter={() => setKrHover(true)}
                onMouseLeave={() => setKrHover(false)}>
            <div>
                <div 
                  className='keyResultName'
                  onClick={() => viewGoalDetails()}
                  role="link"
                  tabIndex={0}
                  onKeyDown={e => {
                    e.stopPropagation()
                    KeyDownEventLink(e, () => viewGoalDetails())
                  }}
                >
                  {clusterData.name}
                </div>
                {clusterData.teamName && <><span className='krDetails'>{clusterData.teamName}</span><span className="dotClass"></span></>}
                {subtitle1 != '' && <><span className='krDetails'>{subtitle1}</span><span className="dotClass"></span></>}
                <span className='krDetails'>{subtitle2}</span><span className="dotClass"></span>
                <span className='krDetails'>{targetText}</span>
            </div>
            {krHover && !clusterFlag ? <div className="button-comp-icon icon icon-outline-link-24px-bluegreen" onClick={updateAsMirrorItem} style={{'alignSelf': 'center', minWidth: '24px'}}></div>: ""}
        </div>
        </>
    );
}

export default KrClusterItem;